import { FC } from 'react'
import { useParams } from 'react-router-dom'
import { useSamplePack } from '../../__legacy__/queries/samplePacks'
import { ArpeggiLoader } from '../lazy-component'
import { SPMainSection, SPSecondarySection } from './components'

export const SamplePackDetails: FC = () => {
  const { samplePackId } = useParams<{ tab: string; samplePackId: string }>()
  const { data } = useSamplePack({ id: +samplePackId })
  if (!data) return <ArpeggiLoader />
  return (
    <>
      <SPMainSection samplePack={data} />
      <SPSecondarySection sp={data} />
    </>
  )
}
